import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  CardBody,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";
import { useFormik } from "formik";
import * as Yup from "yup";
import { post } from "../../api/axios";
import endpoints from "../../api/endpoints";
import logo from "../../assets/images/elevated-logo.svg";
import login from "../../assets/images/login1.png";
import { Bounce, toast } from "react-toastify";

const ResetPassword = (props) => {
  document.title = "Reset Password | Elevated - Admin Dashboard";
  const [apiError, setApiError] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const navigate = useNavigate();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Please Enter Your Email"),
    }),
    onSubmit: async (values) => {
      try {
        const resp = await post(endpoints.reset, {
          email: values.email,
          isAdmin: true,
        });

        if (resp?.data?.success) {
          navigate("/update-password");

          toast.success("Instructions have been sent to your Email", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        } else {
          setApiError("User is not registered.", apiError);
        }
      } catch (error) {
        setApiError("An error occurred. Please try again.");
      }
    },
  });

  return (
    <>
      <div className=" account-pages bg-white">
        <Row className="d-flex align-items-center justify-content-center min-vh-100 g-0 px-3">
          <Col md="6" className="d-none d-xl-block">
            <div className="image-section">
              <img
                src={login}
                alt="Gym Equipment"
                className="object-fit-cover img-fluid w-100 rounded-5 "
                style={{ maxHeight: "96vh" }}
              />
            </div>
          </Col>
          <Col
            md="6"
            className="d-flex align-items-center justify-content-center login-scroll"
          >
            <div className="">
              <Link
                to="/"
                className="mb-3 d-block auth-logo mt-4 mt-md-4 mt-lg-4"
              ></Link>
            </div>

            <div className="pt-4 gap-0">
              <div className="login-container">
                <div className="login-form-wrapper">
                  <div className="logo text-center mb-4">
                    <img
                      src={logo}
                      height={"140px"}
                      alt="Elevated Iron Logo"
                      className="login-logo"
                    />
                  </div>

                  <h2 className="text-center mt-5 ff-sora fw-bold font-size-24 primary-black">
                    Reset Password
                  </h2>
                  <p className="text-center ff-sora font-size-16 secondary-black fw-normal">
                    Kindly provide your email address or phone
                    <br /> number to reset your account password.
                  </p>

                  <Form
                    onSubmit={validation.handleSubmit}
                    className="login-form mx-2 mx-xl-0"
                  >
                    <FormGroup floating>
                      <Input
                        type="email"
                        id="email"
                        placeholder="Email"
                        className={`form-control-lg rounded-pill ff-sora fw-normal font-size-16 primary-black email-input ${
                          validation.values.email || isFocused
                            ? "bg-change"
                            : "bg-light"
                        }`}
                        value={validation.values.email}
                        onChange={validation.handleChange}
                        onBlur={(e) => {
                          validation.handleBlur(e);
                          setIsFocused(false);
                        }}
                        onFocus={() => setIsFocused(true)}
                        invalid={
                          validation.touched.email && validation.errors.email
                            ? true
                            : false
                        }
                        style={{
                          maxWidth: "548px",
                          backgroundColor:
                            validation.values.email || isFocused
                              ? "#EBF5F4"
                              : "#F5F5F5",
                          border: "none",
                        }}
                      />
                      <Label
                        for="email"
                        className="light-black font-size-16 ff-sora fw-normal"
                      >
                        Email
                      </Label>
                      {validation.touched.email && validation.errors.email && (
                        <div className="text-danger">
                          {validation.errors.email}
                        </div>
                      )}
                    </FormGroup>

                    {apiError && <div className="text-danger">{apiError}</div>}

                    <Button
                      type="submit"
                      className="custom-button bg-brand-orange rounded-pill font-size-16 fw-bold ff-sora mt-1"
                    >
                      Reset Password
                    </Button>
                  </Form>

                  <p className="text-center pt-4 ff-sora font-size-14 light-black font-weight-normal pb-0 mb-1">
                    Remember your account password?
                  </p>
                  <p className="text-center pt-0 ff-sora font-size-16 fw-medium mt-0">
                    <Link to="/login" className="brand-orange">
                      Login Here
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default withRouter(ResetPassword);
